import { motion } from "motion/react";
import {
  JourneyNavigation,
  type JourneyController,
} from "./JourneyNavigation";
import { navigate } from "../lib/navigation";
import { usePortfolioStore } from "../state/usePortfolioStore";
import { portfolioProfile } from "../content/portfolio";

interface HomeIntroductionProps {
  journey: JourneyController;
  reducedMotion: boolean;
}

export function HomeIntroduction({
  journey,
  reducedMotion,
}: HomeIntroductionProps) {
  const hasInteracted = usePortfolioStore((state) => state.hasInteracted);
  const setInteracted = usePortfolioStore((state) => state.setInteracted);

  const startJourney = () => {
    setInteracted();
    navigate("/about");
  };

  return (
    <motion.main
      id="main-content"
      className={`home-introduction ${hasInteracted ? "is-awake" : ""}`}
      tabIndex={-1}
      initial={reducedMotion ? false : { opacity: 0, y: 18 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
    >
      <p className="signal-label">
        <span className="mobile-home-owner">{portfolioProfile.name}</span>
        {portfolioProfile.home.signal}
      </p>
      <h1>
        {portfolioProfile.home.headlineLead}
        <span>{portfolioProfile.home.headlineEmphasis}</span>
      </h1>
      <p className="intro-copy">{portfolioProfile.home.introduction}</p>
      <div className="intro-actions">
        <button className="primary-action" type="button" onClick={startJourney}>
          Explore how I work
          <span aria-hidden="true">↗</span>
        </button>
        <button type="button" onClick={() => navigate("/read")}>
          Skip the engine, read the complete portfolio
        </button>
      </div>
      <JourneyNavigation journey={journey} variant="home" />
    </motion.main>
  );
}
